import { QuestionType } from '../resources/survey';

export const questionsWithForwardLogic = new Set([
    QuestionType.ONE_OF_LIST,
    QuestionType.FEW_OF_LIST,
    QuestionType.DROPDOWN_LIST,
    QuestionType.MATRIX_SINGLE_ANSWER,
    QuestionType.MATRIX_FEW_ANSWERS,
    QuestionType.MATRIX_RATING,
    QuestionType.FIRST_CLICK,
    QuestionType.FIGMA_TEST,
]);

export const questionTypesWithColsSelect = new Set([
    QuestionType.MATRIX_RATING,
    QuestionType.MATRIX_SINGLE_ANSWER,
    QuestionType.MATRIX_FEW_ANSWERS,
]);

export const questionsWithForwardLogicAnswers = new Set([
    QuestionType.CSI,
    QuestionType.DISTRIBUTE_SCALE,
    QuestionType.ONE_OF_LIST,
    QuestionType.FEW_OF_LIST,
    QuestionType.DROPDOWN_LIST,
    QuestionType.GROUP_FREE_ANSWERS,
    QuestionType.MATRIX_SINGLE_ANSWER,
    QuestionType.MATRIX_FEW_ANSWERS,
    QuestionType.MATRIX_RATING,
    QuestionType.MATRIX_TEXT_ANSWER,
    QuestionType.RANK,
    QuestionType.NAME,
    QuestionType.CARD_SORTING,
    QuestionType.PAIR_COMPARISON,
    QuestionType.TEXT_PERCEPTION,
]);

export const questionsWithAnswerHide = new Set([
    QuestionType.ONE_OF_LIST,
    QuestionType.FEW_OF_LIST,
    QuestionType.TEST_ONE_OF_LIST,
    QuestionType.TEST_FEW_OF_LIST,
    QuestionType.SELECT_ONE_IMAGE,
    QuestionType.SELECT_FEW_IMAGE,
    QuestionType.DROPDOWN_LIST,
    QuestionType.DISTRIBUTE_SCALE,
    QuestionType.CSI,
    QuestionType.RANK,
    QuestionType.MATRIX_SINGLE_ANSWER,
    QuestionType.MATRIX_FEW_ANSWERS,
    QuestionType.MATRIX_RATING,
    QuestionType.MATRIX_DROPDOWN_LIST,
    QuestionType.MATRIX_TEXT_ANSWER,
    QuestionType.GROUP_FREE_ANSWERS,
    QuestionType.KANO,
]);

export const questionsWithForwardMedia = new Set([QuestionType.AB_TESTING, QuestionType.SELECT_ONE_IMAGE]);
